import { createRouter } from '@tanstack/react-router'

import { queryClient } from '@/shared/lib/query-client'

import { routeTree } from './routeTree.gen'

export const router = createRouter({
	routeTree,
	notFoundMode: 'fuzzy',
	defaultPreload: false, //'intent',
	defaultPendingMinMs: 0,
	defaultPendingMs: 0,
	context: { queryClient },
})
